import { WithAccountId } from '@mews-commander/types';
import { lt } from '@mews/framework';
import { AuthorizationType } from '@mews-commander/data-access';
import { GatewayPaymentFormField } from '../GatewayPaymentForm/schema';
import { PreauthorizationSelectField } from '../../../common/PreauthorizationSelectField';
import { PaymentMethodSelectField } from '../PaymentMethodSelectField/PaymentMethodSelectField';

interface AuthorizationTypeSegmentTabsProps extends WithAccountId {
    activeSegment: AuthorizationType;
    isExternal: boolean;
}

export const AuthorizationTypeSegmentTabs = ({
    activeSegment,
    accountId,
    isExternal,
}: AuthorizationTypeSegmentTabsProps) => {
    switch (activeSegment) {
        case AuthorizationType.Preauthorization:
            return (
                <PreauthorizationSelectField
                    name={GatewayPaymentFormField.PreAuthorizationId}
                    label={lt('Preauthorization')}
                    helper={lt('ProcessPaymentMewsPaymentsPreAuthorizationSelectionHint')}
                    accountId={accountId}
                    isGateway={!isExternal}
                />
            );
        case AuthorizationType.CreditCardPayment: {
            return (
                <PaymentMethodSelectField
                    required
                    name={GatewayPaymentFormField.PaymentMethodId}
                    label={lt('ProcessPaymentMewsPaymentsPaymentMethodSelectLabel')}
                    helper={lt('ProcessPaymentMewsPaymentsCardPaymentCardSelectionHint')}
                    accountId={accountId}
                    isExternal={isExternal}
                />
            );
        }
        default:
            return null;
    }
};
